import { Injectable } from '@angular/core';
import { HTTPAPIConfig, APIConfigMapping, VlDataService, VlHttpService } from 'shared-library';
import { BehaviorSubject, Observable } from 'rxjs';
import { MOB_AND_WEB_ENTITIES } from './models/models';

@Injectable({
  providedIn: 'root'
})
export class WebWidgetPropertyFormService {

  constructor(private dataService: VlDataService, private httpService: VlHttpService) { }

  getEntitySubmissionData(entityId: string): any {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITY_SUBMISSIONS_DATA']);
      apiConfig.postData = {
        entity_id: entityId
      };
      return this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(data);
          observer.complete();
        },
        error: (error: any) => {
          observer.error(error);
          observer.complete();
        }
      });
    })
  }

  getMobAndWebEntities(): any {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_MOB_AND_WEB_ENTITIES']);
      apiConfig.postData = {
        project_id: JSON.parse(localStorage.getItem('ProjectMetaData') as string)?.project_id
      };
      return this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: MOB_AND_WEB_ENTITIES[]) => {
          observer.next(data);
          observer.complete();
        },
        error: (error: any) => {
          observer.error([]);
          observer.complete();
        }
      });
    })
  }

  private tableConfig = new BehaviorSubject<any>({});

  selectedTableConfig$: Observable<any> = this.tableConfig.asObservable();

  setSelectedTableConfig(config:{}){
    this.tableConfig.next(config);
  }
  
}
